// extracted by mini-css-extract-plugin
export default {"imageWrapper":"zH-z","twoColumnImage":"AH-z"};